/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let assignee_id = props.assignee_id
  return {
    variables: {
      assignee_id,
    },
    pause: !assignee_id,
  }
}
